module.exports = __webpack_public_path__ + "img/card.1c151e03.png";